angular
    .module('dnecom')
    .service('StoreLicense', ["$http", "notifications", function($http, notifications) {
        var storage = {};

        this.set = function(name, value) {
            storage[name] = value;
        };

        this.get = function(name) {
            return storage.hasOwnProperty(name) ? storage[name] : null;
        };

        this.getCount = function() {
            return this.get('count');
        };

        this.loadInfo = function(count) {
            (function(context) {
                $http
                    .get(Routing.generate('stores_license'))
                    .success(function(response) {
                        if (response.success) {
                            context.set('count', response.count);
                            context.set('limit', response.limit);
                        } else {
                            notifications.danger(response.error || 'Request error.');
                        }
                    });
            })(this);
        };

        this.getLimit = function() {
            return this.get('limit');
        };

        this.getInfo = function() {
            var limit = this.getLimit(),
                total = this.getCount();

            if (null === limit || null === total) {
                return;
            }

            return 'You have ' + Math.max(0, limit - total) + ' out of ' + limit + ' store licenses remaining';
        };

        return this;
    }]);
